
export enum BankAccountOperations {
    NONE = 0,
    DEPOSIT = 1,
    OBLIGATE = 2,
    TRANSFER = 4,
    CREATE_FUND = 8,
    CHANGE_NAME = 16,
    CHANGE_NOTES = 32,
    VIEW_TRANSACTIONS = 64,
    VIEW_LOGS = 128,
    VIEW_MEMBERS = 256,
    ADJUSTMENT = 512,
    DELETE = 1024,
    CHANGE_ACTUAL_BANK_BALANCE = 2048,
    PURCHASE_TRANSACTIONS = 4096,
    PURCHASE_FUNDS = 8192,
    CREATE_MEMBER = 16384,
    VIEW_BACKUPS = 32768,
}
